import * as types from "./action-types";

const initialState = {
  fetchingSettings: false,
  settings: []
};

const notificationSettings = (state = initialState, action = {}) => {
  switch (action.type) {
    /**Fetch notification settings **/
    case `${types.FETCH_NOTIFICATION_SETTING}_PENDING`:
      return Object.assign({}, state, {
        fetchingSettings: true
      });

    case `${types.FETCH_NOTIFICATION_SETTING}_FULFILLED`:
      return Object.assign({}, state, {
        fetchingSettings: false,
        settings: action.payload || []
      });

    case `${types.FETCH_NOTIFICATION_SETTING}_REJECTED`:
      return {
        isRejected: true,
        error: "get notification settings failed"
      };
    /**Fetch notification settings ends **/
    /** Set notification settings **/
    case `${types.SET_PORTAL_SETTINGS}_PENDING`:
      return Object.assign({}, state, {
        fetchingSettings: true
      });

    case `${types.SET_PORTAL_SETTINGS}_FULFILLED`:
      return Object.assign({}, state, {
        fetchingSettings: false,
        settings: action.payload
      });

    case `${types.SET_PORTAL_SETTINGS}_REJECTED`:
      return {
        isRejected: true,
        error: "get notification settings failed"
      };
    /** Set notification settings emds **/
    default:
      return state;
  }
};

export default notificationSettings;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/reducer.js